export default {
  namespaced: true,
  state: () => ({
    cachedRoutes: [],
    currentPath: '',
    filterMenuKeyword: '',
    removeBackup: null // 用于删除页签后的回退操作
  }),
  getters: {},
  mutations: {
    setFilterMenuKeyword(state, payload) {
      state.filterMenuKeyword = payload
    },
    setCurrentPath(state, payload) {
      state.currentPath = payload
    },
    addCachedRoute(state, {to, from}) {
      if(to.meta?.fixedTab) {
        state.cachedRoutes.unshift(to)
      } else {
        if(!state.cachedRoutes.length) {
          state.cachedRoutes.push(to)
        } else {
          // 如果带有要替换的tab，则替换掉
          if (to.params.replaceTab) {
            // 根据 params.replaceTab 进行替换
            const index = state.cachedRoutes.findIndex(item => item.fullPath === to.params.replaceTab)
            if(index > -1) {
              state.cachedRoutes.splice(index, 1, to)
              return
            }
          } else if (to.meta.replaceSameTab) {
            // 根据路由配置的 replaceSameTab 进行替换
            const index = state.cachedRoutes.findIndex(item => item.name === to.name)

            if(index > -1) {
              state.cachedRoutes.splice(index, 1, to)
              return
            }
          }

          // 如果没有要替换的tab，则在当前页签后面插入
          const index = state.cachedRoutes.findIndex(item => item.fullPath === from.fullPath)
          if(index > -1) {
            state.cachedRoutes.splice(index + 1, 0, to)
          }
        }
      }
    },
    removeCachedRoute(state, payload) {
      const index = state.cachedRoutes.findIndex(item => item.fullPath === payload.fullPath)

      if (index > -1) {

        let removeRoute = state.cachedRoutes.splice(index, 1)

        state.removeBackup = {
          route: removeRoute[0],
          index: index
        }
      }
    },
    backupRoute(state) {
      if (!state.removeBackup) return

      console.log('backupRoute')

      state.cachedRoutes.splice(state.removeBackup.index, 0, state.removeBackup.route)

      state.currentPath = state.removeBackup.route.fullPath
    }
  },
  actions: {}
}

